import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Showcase } from './components/Showcase';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Features data-id="element-4" />
        <Showcase data-id="element-5" />
        <Pricing data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FAQ data-id="element-8" />
        <CTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}